import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import cx from 'classnames';
import { connect } from 'react-redux';
import Translate from 'client/components/translate';
import Button from 'client/components/button/button';
import InputGroup from 'client/components/form/inputGroup';
import LinkReplace from 'client/components/button/linkReplace';
import { resetPassword } from 'client/actions/user';

import Hero from './hero';


const mapStateToProps = state => ({
  brandName: state.brand,
});

const propTypes = {
  location: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  brandName: PropTypes.string.isRequired,
  resetPassword: PropTypes.func.isRequired,
};

class ResetPage extends Component {
  constructor(props) {
    super(props);
    this.email = this.props.params.email;
    this.code = this.props.params.code;
    this.state = {
      submitting: false,
      submitted: false,
      password: {
        value: '',
        error: null,
      },
      passwordConfirm: {
        value: '',
        error: null,
      },
    };
  }

  validatePassword(state, password) {
    const newState = {
      password: {
        error: null,
      },
    };
    if (!password) {
      newState.password.error = { path: 'common.form.error.required' };
    } else if (password.length < 8) {
      newState.password.error = { path: 'common.error.passwordLength' };
    }
    return this.mergeVals(state, newState);
  }

  validateConfirmPassword(state, password) {
    const newState = {
      passwordConfirm: {
        error: null,
      },
    };
    if (!password) {
      newState.passwordConfirm.error = { path: 'common.form.error.required' };
    } else if (password !== state.password.value) {
      newState.passwordConfirm.error = { path: 'common.error.nonMatchingPasswords' };
    }
    return this.mergeVals(state, newState);
  }

  mergeVals(state, newVals) {
    return _.merge({}, state, newVals);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { password, passwordConfirm } = this.state;
    let newState;
    newState = this.validatePassword(this.state, password.value);
    newState = this.validateConfirmPassword(newState, passwordConfirm.value);
    if (!newState.password.error && !newState.passwordConfirm.error) {
      newState.submitting = true;
      const params = {
        email: this.email,
        password: password.value,
        code: this.code,
      };
      this.props.resetPassword(params)
        .then((res) => {
          this.setState({
            submitting: false,
            submitted: _.get(res, 'data.status') === 'OK',
          });
        })
        .catch(() => {
          this.setState({
            submitting: false,
          });
        });
    }
    this.setState(newState);
  }

  renderForm() {
    const { password, passwordConfirm, submitting } = this.state;
    return (
      <div className="pad-x-small-only">
        <h4>
          <Translate
            path={this.state.submitted ? false : 'common.account.reset.hero.initial'} />
        </h4>
        <form onSubmit={this.handleSubmit}>
          <InputGroup
            autoComplete="off"
            id="password"
            label={{
              path: 'common.label.passwordNew',
            }}
            type="password"
            value={this.state.password.value}
            onChange={(e) => {
              const newVal = e.target.value;
              let newState = this.mergeVals(this.state, { password: { value: newVal } });
              if (password.error) {
                newState = this.validatePassword(newState, newVal);
              }
              this.setState(newState);
            }}
            onBlur={() => {
              this.setState(this.validatePassword(this.state, password.value));
            }}
            error={password.error} />
          <InputGroup
            id="password-confirm"
            label={{
              path: 'common.label.passwordConfirm',
            }}
            type="password"
            value={this.state.passwordConfirm.value}
            onChange={(e) => {
              const newVal = e.target.value;
              let newState = this.mergeVals(this.state, { passwordConfirm: { value: newVal } });
              if (passwordConfirm.error) {
                newState = this.validateConfirmPassword(newState, newVal);
              }
              this.setState(newState);
            }}
            onBlur={() => {
              this.setState(this.validateConfirmPassword(this.state, passwordConfirm.value));
            }}
            error={passwordConfirm.error} />
          <div className="text-center">
            <Button
              className={cx('cta-button', { submitting })}
              type="submit">
              <Translate path="common.account.reset.cta" />
            </Button>
          </div>
        </form>
      </div>
    );
  }

  renderConfirmation() {
    return (
      <div className="text-center">
        <p className="margin-bottom-2">
          <Translate
            path="common.account.reset.confirmation"
            using={{ email: this.email }} />
        </p>
        <LinkReplace
          to={{
            pathname: '/login',
            query: this.props.location.query,
          }}
          state={{
            locationUsername: this.email,
          }}>
          <Button className="cta-button">
            <Translate path="common.account.reset.goToLogin" />
          </Button>
        </LinkReplace>
      </div>
    );
  }

  render() {
    return (
      <div className="account-page">
        <Hero brandName={this.props.brandName} />
        <div className="center-col" style={{ paddingBottom: '4rem' }}>
          <div className="form-container pad-y-2 medium-margin-top-2">
            <div className="center-col-small pad-x-small-only">
              {this.state.submitted
                ? this.renderConfirmation()
                : this.renderForm()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
ResetPage.propTypes = propTypes;

export default connect(mapStateToProps, {
  resetPassword,
})(ResetPage);
